/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Dokumente anzeigen (PDFs)
 *
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as appActions from "../../../store/actions/appActions";
import * as utils from "../../../basics/utils";
import ProductToolbar from "./ProductToolbar";
import PDFFrame from "../../partials/PDFFrame";

class ProductDocuments extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;

        this.oauthPopup = null
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { unitHeight, path, orientation, appModus } = this.props.app;

        const node = utils.getTreePortfolio(path, false);
        if (node === null) return null;

        const scrollBarClass = (window['cordova']) ? 'overflow-y-hidden' : 'overflow-y-auto';

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderDocuments = () => {

            const renderPDF = (d, i) => {
                return (
                    <div key={i} className="w-full pr-1">
                        <PDFFrame key={i} node={d} type='product' listView={false} />
                    </div>
                )
            }

            let pdfList = [];
            if (appModus === 'Admin') {
                // Im Admin-Modus werden auch Preislisten in der Liste der PDF-Dokumente angezeigt.
                pdfList = node.filter(f => utils.getFileExtension(f.name) === 'pdf');
            } else {
                // Im User-Modus dürfen Preislisten nicht angezeigt werden, damit diese auch nicht versendet werden können.
                // Es erscheint ein Extra Button unten in der Toolbar, um Preislisten ohne-Versand Möglichkeit anzuzeigen.
                pdfList = node.filter(f => utils.getFileExtension(f.name) === 'pdf' && utils.checkPriceListPDF(f.name) === false);
            }

            const style = {
                height: '56%',
                backgroundColor: (this.debug) ? 'pink' : ''
            }

            return (
                <div className={`w-full flex overflow-y-hidden ${scrollBarClass}`} style={style}>
                    {appModus === 'Admin' && renderPDF({ name: '_NEW', path: '' })}
                    {pdfList.map((d, i) => renderPDF(d, i))}
                </div>
            )
        }

        const renderFiller = () => {

            const style = {
                height: '4%',
                backgroundColor: (this.debug) ? 'blue' : '',
            };

            return (<div className="w-full" style={style}></div>);
        }

        const renderToolbar = () => {

            const style = {
                height: '40%',
                backgroundColor: (this.debug) ? 'blue' : '',
            };

            return (
                <div className="w-full" style={style}>
                    <ProductToolbar node={node} height={unitHeight * ((orientation === 'landscape') ? .6 : .5)} />
                </div>
            );
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        return (
            <div className="w-full h-full flex flex-col">
                {renderDocuments()}
                {renderFiller()}
                {renderToolbar()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDocuments);
